<template>
  <div>

      <!-- Table with finished mandates -->
      <CRow>
        <BootstrapVueTable class="col-12" style="height: 600px"
          :sticky_header="sticky_header"
          :search=false
          :title="title_finished+total_profits_finished"
          :subtitle="subtitle_finished"
          :items="table_data_finished"
          :fields="table_fields_finished" />
      </CRow>

      <!-- Table with mandates ending this year -->
      <CRow>
        <BootstrapVueTable class="col-12" style="height: 600px" 
          :sticky_header="sticky_header"
          :search=false
          :title="title_to_finish+total_profits_to_finish"
          :subtitle="subtitle_to_finish"
          :items="table_data_to_finish"
          :fields="table_fields_to_finish" />
      </CRow>

      <!-- Table with mandates ending later -->
      <CRow >
        <BootstrapVueTable class="col-12" style="height: 600px"
          :sticky_header="sticky_header"
          :search=false
          :title="title_ongoing+total_profits_ongoing"
          :subtitle="subtitle_ongoing"
          :items="table_data_ongoing"
          :fields="table_fields_ongoing" />
      </CRow>
  </div>
</template>

<script>
import axios from 'axios'
import errorRoutingMixin from '@/mixins/errorRoutingMixin'
import data_formats from '@/utils/data_formats'
import BootstrapVueTable from '@/components/BootstrapVueTable'

export default {
  name: 'Project_mandate_data',
  components: {BootstrapVueTable},
  mixins: [errorRoutingMixin],
  props: ['reference_entity', 'reference_year', 'reference_month'],
  data () {
    return {
      title_finished: "Mandats terminés",
      subtitle_finished: "Cette table montre les mandats terminés et les bénéfices réalisés cette année. Ces bénéfices sont déjà intégrés dans le chiffre d'affaires de l'institut.",
      title_to_finish: "Mandats à terminer",
      subtitle_to_finish: "Cette table montre les mandats qui se termineront cette année. Les bénéfices prévus seront disponibles cette année.",
      title_ongoing: "Mandats à continuer",
      subtitle_ongoing: "Cette table montre les mandats qui se termineront ultérieurement. Les bénéfices accumulés ne sont pas disponibles cette année.",
      raw_data: [],
      table_data_finished: [],
      table_fields_finished: [],
      total_profits_finished: "",
      table_data_to_finish: [],
      table_fields_to_finish: [],
      total_profits_to_finish: "",
      table_data_ongoing: [],
      table_fields_ongoing: [],
      total_profits_ongoing: "",
      sticky_header: "500px",
    }
  },
  watch: {
    all_props () {
      this.load_server_data()
    }
  },
  created () {
    this.load_server_data()
  },
  computed: {
    all_props () {
      return [
        this.reference_entity,
        this.reference_year,
        this.reference_month  
      ]
    },
  },
  methods: {
    load_server_data () {
      if (! this.reference_entity) return  // If user is not yet authenticated. do nothing
      let url = 'webapi/mandate-financials?entity=' + this.reference_entity + '&year=' + this.reference_year + '&month=' + this.reference_month 
      axios.get(url, {headers: {'Authorization': 'Bearer ' + this.$cookies.get('jwt_access')}})
        .then(response => this.raw_data = response.data)
        .then(_ => this.fill_tables())
        .catch(error => {
          console.log(error)
          this.$router.push(this.routeOnError(error.response.status))
        })
    },

    sum_of_profits(data) {
      let total = data.reduce((sum, r) => sum + r.TotalProfit, 0.0)
      let formatted = " (Total: " + data_formats.number_format_frch_rounded(total) + ")"
      return formatted
    },

    fill_tables() {
      let end_of_year = new Date(this.reference_year, 11, 31) 
      let data = data_formats.col_to_row_format(this.raw_data)
      this.table_data_finished = data.filter(r => ['TS', 'TA', 'AC'].includes(r.ProjectStatus))
      this.table_data_to_finish = data.filter(r => ! ['TS', 'TA', 'AC'].includes(r.ProjectStatus) && new Date(r.PROJECTENDDATE) <= end_of_year)
      this.table_data_ongoing = data.filter(r => ! ['TS', 'TA', 'AC'].includes(r.ProjectStatus) && new Date(r.PROJECTENDDATE) > end_of_year)
      this.total_profits_finished = this.sum_of_profits(this.table_data_finished)
      this.total_profits_to_finish = this.sum_of_profits(this.table_data_to_finish)
      this.total_profits_ongoing = this.sum_of_profits(this.table_data_ongoing)

      let sortable = {sortable: true}
      let number_format = {formatter: data_formats.number_format_frch_rounded, class: 'text-right', ...sortable}
      let date_format = {formatter: data_formats.date_format_frch_short, class: 'text-left', ...sortable}

      let table_fields = [
        {key: 'IDPROJECTHESSO', label: 'No.', ...sortable}, 
        {key: 'PROJECTMANAGERINITIAL', label: 'Resp.', ...sortable}, 
        {key: 'PROJECTACRONYM', label: 'Acronyme', ...sortable}, 
        {key: 'IDPILIER', label: 'Pilier', ...sortable}, 
        {key: 'ProjectStatus', label: 'Statut', ...sortable}, 
        {key: 'PROJECTENDDATE', label: 'Fin', ...date_format}, 
      ]
      this.table_fields_finished = [ ...table_fields, {key: 'TotalProfit', label: 'Bénéfices réalisés', ...number_format} ]
      this.table_fields_to_finish = [ ...table_fields, {key: 'TotalProfit', label: 'Bénéfices prévus', ...number_format} ]
      this.table_fields_ongoing = [ ...table_fields, {key: 'TotalProfit', label: 'Bénéfices accumulés', ...number_format} ]
    },
  }
}
</script>